import { ContentLink, useContentSingletons, useMultipleContents, usePageContent } from "@robe/client/xcore-ui";
import { Box, Button, Flex, SimpleGrid, Tag, Typography } from "@xcorejs/ui";
import { News, NewsDetailPage } from "xcore/types";
import { useLayout } from "../../xcore";
import NewsCard from "../../design-system/robe/Cards/News";

export const MoreNews = () => {
  const { subCategories } = usePageContent<News>();
  const [news] = useMultipleContents<[News]>();
  const [detailPage] = useContentSingletons<[NewsDetailPage]>();
  const { header, general, stringify } = useLayout();

  return (
    <Box>
      <Typography variant="h3" as="h2" textAlign="center" mb="2rem">
        {stringify(detailPage.values.discoverMoreNews)}
      </Typography>

      <Flex justifyContent="center" flexWrap="wrap" mb="3rem">
        {subCategories?.["news-categories"]?.map((c) => (
          <ContentLink content={header.nav.newsPage} key={c.id} queries={{ category: c.id }} variant="simple">
            <Tag key={"tag_" + c.id} variant="outline" {...TagStyle}>
              {stringify(c.name)}
            </Tag>
          </ContentLink>
        ))}
      </Flex>

      <Flex width="100%" justifyContent="center" alignItems="center" flexDirection="column">
        <SimpleGrid gap="3rem" columns={{ _: 1, sm: 2, lg: 4 }} column="minmax(100px, 300px)" width={{ _: "auto", lg: "100%" }}>
          {news.map((c) => (
            <ContentLink key={c.id} content={c} height="100%">
              <NewsCard content={c} variant="outline" />
            </ContentLink>
          ))}
        </SimpleGrid>
        <Button as="a" href="/news" mt={{ _: "3rem", sm: "6rem" }}>
          {stringify(general.values.readMore)}
        </Button>
      </Flex>
    </Box>
  );
};

const TagStyle = {
  margin: ".5rem",
  cursor: "pointer",
  transition: "background 300ms",
  color: "#E00034",
  borderColor: "#E00034",

  _hover: {
    background: "#E00034",
    color: "#fff",
  },
};
